<template>
<div class="chapter">
<div class="inner_page">
<p class="copy-t1"><span class="gbold">SLAVE NO MORE</span></p>
<p class="copy-t2">Conquering the Master Within</p>
<p class="copy">© 2022 Paul A. Henderson</p>
<p class="copy">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
<p class="copy">Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. <a href="http://www.MorganJamesPublishing.com" target="_blank">www.MorganJamesPublishing.com</a></p>
<p class="copy">Proudly distributed by Ingram Publisher Services.</p>
<table>
<tbody><tr>
<td><p class="image"><img alt="image" src="images/copy.png"/></p></td>
<td>
<p class="copy">ISBN 9781631955945 paperback</p>
<p class="copyn">ISBN 9781631955952 ebook</p>
<p class="copyn">Library of Congress Control Number: 2021936027</p>
<p class="copytn"><span class="abold">Cover Concept by:</span></p>
<p class="copyn">Kierra Henderson</p>
<p class="copytn"><span class="abold">Cover and Interior Design by:</span></p>
<p class="copyn">Chris Treccani</p>
<p class="copyn"><a href="http://www.3dogcreative.net" target="_blank">www.3dogcreative.net</a></p>
<p class="copytn"><span class="abold">Author Photo by:</span></p>
<p class="copyn">DeAudrea ‘Sha’ Rich</p>
<p class="copytn"><span class="abold">Interior Illustrations by:</span></p>
<p class="copyn">Michael Stock</p>
</td>
</tr>
</tbody></table>
<p class="imagel"><img alt="image" src="images/logo.png"/></p>
<p class="copyc">Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.</p>
<p class="copyc">Get involved today! Visit <a href="http://MorganJamesPublishing.com/giving-back" target="_blank">MorganJamesPublishing.com/giving-back</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?cfe4c980